import React, { useEffect, useState } from "react";
import arrows from "../../assets/images/right.svg";
import AboutusModal from "../Modals/AboutusModal";
import DMCAPolicyModal from "../Modals/DMCAPolicyModal";
import TermModal from "../Modals/TermModal";
import PrivacyPolicyModal from "../Modals/PrivacyPolicyModal";
import OtherModal from "../Modals/OtherModal";
import ContactModal from "../Modals/ContactModal";
import { Home } from "../../Redux/Action/Action";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import logowhite from '../../assets/images/logo-white.png'


function Footer() {
  const dispatch = useDispatch()
  const handleScroll = () => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  };
  const [aboutUsModal, SetAboutUsModal] = useState(false);
  const [DMCAModal, SetDMCAModal] = useState(false);
  const [termModal, SetTermModal] = useState(false);
  const [privacyModal, SetPrivacyModal] = useState(false);
  const [otherModal, SetOtherModal] = useState(false);
  const [contactModal, SetContactModal] = useState(false);

  return (
    <>
      <footer className="footer-section">
        <div className="container-fluid">
          <div className="footer-logo-grid" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: true">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                <div className="footer-logo">
                  <Link to={'/'}
                    onClick={() => {
                      localStorage.removeItem('selectedCity')
                      dispatch(Home())   // ✅ set active to Home
                    }}><img src={logowhite} className="img-fluid" alt="Logo" /></Link>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-8 col-lg-8">
                <div className="footer-content">
                  <p>We can help you plan the perfect vacation. Our travel website makes it easy to find the ideal trip and book one today! Check out our deals on flights, hotels, cruises, adventure tours, car rentals, tours, and more. We have partnered with more than 700+ airlines, over 500,000+ hotel locations, and thousands of travel sites worldwide. With so much to see and do, you want to ensure you've got the best travel plans. That's why we created our site: to help you find a great vacation package you can't find anywhere else.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-details-block">
            <div className="row">
              <div className="col-lg-4 mb-3 mb-lg-0">
                <div className="footer-link-block d-flex gap-0 gap-md-3">
                  <div className="footer-social-icon" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: true">
                    <ul className="d-flex justify-content-center justify-content-md-end gap-3 p-0">
                      <li><a href=""><i className="fa-brands fa-facebook-f"></i></a></li>
                      <li><a href=""><i className="fa-brands fa-instagram"></i></a></li>
                      <li><a href=""><i className="fa-brands fa-linkedin-in"></i></a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="footer-link-block gap-0" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: true">
                  <div className="footer-heading mb-2">Useful Links:</div>
                  <div className="footer-nav">
                    <ul className="p-0">
                      <li><span onClick={() => SetAboutUsModal(true)}>About Us</span></li>
                      <li><span onClick={(e) => {
                        e.preventDefault();
                        SetDMCAModal(true);
                      }}>DMCA Policy</span></li>
                      <li><span onClick={(e) => {
                        e.preventDefault();
                        SetTermModal(true);
                      }}>Terms & Conditions</span></li>
                      <li><span onClick={(e) => {
                        e.preventDefault();
                        SetPrivacyModal(true);
                      }}>Privacy Policy </span></li>
                      <li><span onClick={() => SetContactModal(true)}>Contact Us</span></li>
                    </ul>
                  </div>
                  <div className="footer-heading mb-2 mt-4">Stay Updated</div>
                  <div className="subscribe-form">
                    <form>
                      <div className="form-group">
                        <input type="email" className="form-control" placeholder="Enter Email Address..." />
                        <button type="submit" className="">Submit</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="copy-right-section text-center py-3" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: true">
            <p> © {new Date().getFullYear()} mysittivacations.com</p>
          </div>
        </div>
        <div className="scrollup" onClick={handleScroll}>

          <img loading="lazy" src={arrows} alt="arrows" />

        </div>
      </footer>
      {aboutUsModal && (
        <AboutusModal
          aboutUsModal={aboutUsModal}
          SetAboutUsModal={SetAboutUsModal}
        />
      )}
      {DMCAModal && (
        <DMCAPolicyModal DMCAModal={DMCAModal} SetDMCAModal={SetDMCAModal} />
      )}
      {termModal && (
        <TermModal termModal={termModal} SetTermModal={SetTermModal} />
      )}
      {privacyModal && (
        <PrivacyPolicyModal
          privacyModal={privacyModal}
          SetPrivacyModal={SetPrivacyModal}
        />
      )}
      {otherModal && (
        <OtherModal otherModal={otherModal} SetOtherModal={SetOtherModal} />
      )}
      {contactModal && (
        <ContactModal
          contactModal={contactModal}
          SetContactModal={SetContactModal}
        />
      )}
    </>
  );
}
export default Footer;
